import { render, staticRenderFns } from "./sign-up-form.vue?vue&type=template&id=8b5dd1ba&scoped=true&"
import script from "./sign-up-form.vue?vue&type=script&lang=js&"
export * from "./sign-up-form.vue?vue&type=script&lang=js&"
import style0 from "./sign-up-form.vue?vue&type=style&index=0&id=8b5dd1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5dd1ba",
  null
  
)

export default component.exports